
export const buildPlatformProfileUrl = (platformKey, handle) => {
    const normalizedHandle = String(handle || "").replace(/^@/, "").trim();
    if (!normalizedHandle) return "";

    if (platformKey === "instagram") return `https://www.instagram.com/${normalizedHandle}/`;
    if (platformKey === "tiktok") return `https://www.tiktok.com/@${normalizedHandle}`;

    return "";
};

export const doesProfileUrlMatchHandle = (platformKey, handle, profileUrl) => {
    const normalizedUrl = String(profileUrl || "").trim().toLowerCase();
    const normalizedHandle = String(handle || "").replace(/^@/, "").trim().toLowerCase();

    if (!normalizedUrl || !normalizedHandle) {
        return false;
    }

    if (platformKey === "instagram") {
        return normalizedUrl.includes("instagram.com/") && normalizedUrl.includes(`/${normalizedHandle}`);
    }

    if (platformKey === "tiktok") {
        return normalizedUrl.includes("tiktok.com/") && normalizedUrl.includes(`/@${normalizedHandle}`);
    }

    return normalizedUrl.includes(normalizedHandle);
};

export const getVerificationPresentation = (status) => {
    const normalized = String(status || "").trim().toLowerCase();

    if (normalized === "verified") {
        return {
            label: "Verified",
            className: "bg-emerald-50 text-emerald-700 border-emerald-200",
            helpText: "Ownership has been confirmed for this account.",
        };
    }

    if (normalized === "pending") {
        return {
            label: "Verification pending",
            className: "bg-amber-50 text-amber-700 border-amber-200",
            helpText: "A verification step has started but is not complete yet.",
        };
    }

    return {
        label: "Needs verification",
        className: "bg-slate-100 text-slate-700 border-slate-200",
        helpText: "We have the handle, but ownership is not confirmed yet.",
    };
};

export const getExistencePresentation = (status) => {
    const normalized = String(status || "").trim().toLowerCase();

    if (normalized === "exists") {
        return {
            tone: "success",
            message: "Username found.",
        };
    }

    if (normalized === "not_found") {
        return {
            tone: "error",
            message: "Username was not found on this platform.",
        };
    }

    if (normalized === "checking") {
        return {
            tone: "muted",
            message: "Checking username availability...",
        };
    }

    if (normalized === "format_error") {
        return {
            tone: "error",
            message: "Username format is invalid for this platform.",
        };
    }

    if (normalized === "error") {
        return {
            tone: "error",
            message: "We could not check this username right now.",
        };
    }

    return {
        tone: "muted",
        message: "Username existence check needs a backend verification endpoint.",
    };
};

export const getOwnershipHelp = (platformName) =>
    `To prove ownership of ${platformName}, we need either OAuth account linking or a backend flow that checks a one-time code in the user's bio or profile.`;

